module.exports = __webpack_public_path__ + "img/framework.28195411.png";